import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  panel: {
    padding: '0px 0 10px 20px',
  },
}));
